import React from 'react';
import Display from './Display';
import Editor from './Editor';

const Date = {
  // Sub-components
  designer: () => <div />,
  display: Display,
  editor: Editor,
};

export default Date;



// WEBPACK FOOTER //
// ./src/components/types/Date/index.js